import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, WhiteSpace, DatePicker, List, Button, InputItem  } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import  moment from 'moment';

import { getQueryTradeRecords } from '../../action/investmentAction';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';

const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

const NewDate = new Date();




/*智投历史收益查询*/
class ChooseTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalFlag:false,
      sDate:moment(now),
      eDate:moment(now)
    }
  }
  componentWillMount(){
    let { dispatch } = this.props;
    let that = this;
    let data = {
      superFundCode:"",
      pageIndex:1,
      pageSize:99,
    }
    //document.getElementsByTagName('title')[0].innerHTML = "交易记录";
    //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))
  }
  callbackData(data){
    console.log(data,"************")
  }
  goBack(){
    //hashHistory.go(-1)
    this.props.closeBack()
  }


  goTransactionDetail(item){
    let data = {
      businessType:item.businessType,
      tradeRequestId:item.tradeRequestId
    }
    hashHistory.push({
        pathname:'/TransactionDetail',
        state:{
          data
        }
    })
  }

  onOk(e){
    let { dispatch } = this.props;
    console.log(e.format('YYYY-MM-DD'),"eeeeee")
    // this.setState({ sValue:e })
    // let data = {
    //   superFundCode:e[0],
    //   pageIndex:1,
    //   pageSize:30,
    // }
    // if(e[0] === "0000"){
    //   data.superFundCode = ""
    // }
    //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),this))
  }
  onOkEndTime(e){
    let { dispatch } = this.props;
    console.log(e.format('YYYY-MM-DD'),"eeeeee")
  }
  handleSearch(){
    let { sDate, eDate } = this.state;
    this.props.callback(sDate.format('YYYY-MM-DD'),eDate.format('YYYY-MM-DD'))
  }
  render() {
    let data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
    let tempData = [{businessTime:"0000"}];
    tempData = tempData.concat(data);
    return (
        <div style={{ position:"absolute", top:0, left:0, width:"100%", width:"100%", height:"100%" , background:"#FFF"}}>
          <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex:1, flex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, flex:2, textAlign:'center',fontSize:"0.3rem" }}>自选周期</div>
            <div style={{ WebkitFlex:1, flex:1, textAlign:'right',fontSize:"0.28rem", paddingRight:'0.26rem' }}></div>    
          </div>
          </NavigatorMain>
          <div className="content">

          <div className="chooseDate" style={{borderBottom:"1px solid #ebeef0", position:'relative', zIndex:9 }}>
            <DatePicker
              mode="date"
              title="选择时间"
              extra="Optional"
              value={this.state.sDate}
              onChange={sDate => this.setState({ sDate })}
              onOk={(e)=>{ this.onOk(e) } }
            >
          
              <List.Item arrow="horizontal">起始时间</List.Item>
            </DatePicker>
          </div>

          <div className="chooseDate" style={{borderBottom:"1px solid #ebeef0"}}>
            <DatePicker
              mode="date"
              title="选择时间"
              extra="Optional"
              value={this.state.eDate}
              onChange={eDate => this.setState({ eDate })}
              onOk={(e)=>{ this.onOkEndTime(e) } }
            >
          
              <List.Item arrow="horizontal">终止时间</List.Item>
            </DatePicker>
          </div>


          {/*
            <div style={{ background:"#FFF", height:"45px", borderBottom:"1px solid #ebeef0", display:"flex", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px" }}>
              <div>起始时间</div>
              <div style={{display:"flex", flexDirection:"row", alignItems: "center" }}>
                <span>2017-11-09</span>
                <span style={{height:"45px", width:"45px", background:`url(${require("../../img/my_assets_item_foot.png")})`, backgroundSize:"cover" }}></span>
              </div>
            </div>

            <div style={{ background:"#FFF", height:"45px", borderBottom:"1px solid #ebeef0", display:"flex", justifyContent:"space-between", flexDirection:"row", alignItems:"center", paddingLeft:"13px" }}>
              <div>终止时间</div>
              <div style={{display:"flex", flexDirection:"row", alignItems: "center" }} >
                <span>2017-11-09</span>
                <span style={{height:"45px", width:"45px", background:`url(${require("../../img/my_assets_item_foot.png")})`, backgroundSize:"cover" }}></span>
              </div>
            </div>
            
          */}

          <div onClick={ ()=> { this.handleSearch() } } style={{marginTop:"20px", marginLeft: "13px", marginRight: "13px", borderRadius: "20px", backgroundColor: "rgb(254, 73, 46)", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "center", display: "flex" }}>
            <span style={{color: "rgb(255, 255, 255)", fontSize: "15px"}}>查询</span>
          </div>

          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords
  }
}

export default connect(mapStateToProps)(ChooseTime);





// WEBPACK FOOTER //
// ./src/components/product/ChooseTime.js